export const industriesServedData = [
	{
		title: "All/Generic",
		iconPath: "/images/product-submission-form-v2/industries-served/all-generic.svg",
	},
	{
		title: "Residential",
		iconPath: "/images/product-submission-form-v2/industries-served/residential.svg",
	},
	{
		title: "Commercial",
		iconPath: "/images/product-submission-form-v2/industries-served/commercial.svg",
	},
	{
		title: "Single Family",
		iconPath: "/images/product-submission-form-v2/industries-served/single-family.svg",
	},
	{
		title: "Short-term Rentals",
		iconPath: "/images/product-submission-form-v2/industries-served/short-term-rentals.svg",
	},
	{
		title: "Multi-family",
		iconPath: "/images/product-submission-form-v2/industries-served/multifamily.svg",
	},
	{
		title: "Construction",
		iconPath: "/images/product-submission-form-v2/industries-served/construction.svg",
	},
	{
		title: "Retail",
		iconPath: "/images/product-submission-form-v2/industries-served/retail.svg",
	},
	{
		title: "Hotels",
		iconPath: "/images/product-submission-form-v2/industries-served/hotels.svg",
	},
	{
		title: "Resorts",
		iconPath: "/images/product-submission-form-v2/industries-served/resorts.svg",
	},
	{
		title: "Paying Guest(PGs)",
		iconPath: "/images/product-submission-form-v2/industries-served/paying-guests.svg",
	},
	{
		title: "Restaurants",
		iconPath: "/images/product-submission-form-v2/industries-served/restaurants.svg",
	},
	{
		title: "Travel & Tourism",
		iconPath: "/images/product-submission-form-v2/industries-served/travel-and-tourism.svg",
	},
	{
		title: "Industrial",
		iconPath: "/images/product-submission-form-v2/industries-served/industrial.svg",
	},
	{
		title: "Office",
		iconPath: "/images/product-submission-form-v2/industries-served/office.svg",
	},
	{
		title: "Healthcare",
		iconPath: "/images/product-submission-form-v2/industries-served/healthcare.svg",
	},
	{
		title: "Agriculture",
		iconPath: "/images/product-submission-form-v2/industries-served/agriculture.svg",
	},
	{
		title: "Goverment/Public",
		iconPath: "/images/product-submission-form-v2/industries-served/government-public.svg",
	},
	{
		title: "Banks",
		iconPath: "/images/product-submission-form-v2/industries-served/banks.svg",
	},
	{
		title: "Universities & Students",
		iconPath: "/images/product-submission-form-v2/industries-served/universities-and-students.svg",
	},
];
